import styles from "../styles/DocumentsView.module.css";

const DocumentsView = () => {
  return (
    <div className={styles.container}>
      <h2>Документы</h2>
      <p>Здесь хранятся и управляются все внутренние документы компании.</p>
    </div>
  );
};

export default DocumentsView;
